import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-box-outline",
  "use": "add-box-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add-box-outline\"><path fill-rule=\"evenodd\" d=\"M11 7h2v4h4v2h-4v4h-2v-4H7v-2h4V7ZM4 20h16V4H4v16ZM20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol